<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Data aplicação', 'Data movimento', 'Data vencimento aplicação', 'modalidade da captação',
      'Número da aplicação', 'Prazo da aplicação', 'Taxa CDI diário', 'Valor inicial aplicado', 'Valor saldo diário'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataAplicacao)" />
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataMovimento)"/>
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataVencimentoAplicacao)" />
        <TableColumn :IsText="true" :status="1" :value="obj.modalidadeCaptacao" />
        <TableColumn :IsText="true" :status="1" :value="parseInt(obj.numeroAplicacao).toString()" />
        <TableColumn :IsText="true" :status="1" :value="parseInt(obj.prazoAplicacao).toString()" />
        <TableColumn :IsText="true" :status="1" :value="obj.taxaCdiDiario.toString()" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorInicialAplicado ? formatValue(obj.valorInicialAplicado) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoDiario ? formatValue(obj.valorSaldoDiario) : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import CRDRepository from '@/shared/http/repositories/business/captacaoremuneradadiaria.js'
import Tools from '@/components/tools/Tools'

export default {
  name: 'CaptacaoRemuneradaDiaria',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadCaptacaoRemuneradaDiaria(this.document)
      }
    },
    onLoadCaptacaoRemuneradaDiaria (document) {
      loading.push()
      this.document = document
      CRDRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/captacaoremuneradadiaria.vue